import { render, staticRenderFns } from "./shenReceivedDetail.vue?vue&type=template&id=66882004&"
import script from "./shenReceivedDetail.vue?vue&type=script&lang=js&"
export * from "./shenReceivedDetail.vue?vue&type=script&lang=js&"
import style0 from "./shenReceivedDetail.vue?vue&type=style&index=0&id=66882004&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports